import { Actions, ActionTypes } from './actions';
import { orderAdapter, initialState, OrderState } from './state';
import * as actions from './actions';

export function orderReducer(state = initialState, action: Actions): OrderState {
  switch (action.type) {
    case ActionTypes.LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_SUCCESS: {
      return orderAdapter.setAll(action.items, {
        ...state,
        isLoading: false,
        error: null,
      });
    }
    case ActionTypes.FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    }
    case ActionTypes.LOAD_BY_ID_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_BY_ID_SUCCESS: {
      return orderAdapter.setAll(action.items ? [action.items] : [], {
        ...state,
        isLoading: false,
        error: null,
      });
    }
    case ActionTypes.SET_FILTERTYPE_REQUEST: {
      return {
        ...state,
        filterType: action.filterType,
      };
    }
    case ActionTypes.SET_SELECTED_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.SET_SELECTED_SUCCESS: {
      return {
        ...state,
        selected: { ...action.order },
        isLoading: false,
        error: null,
      };
    }

    case ActionTypes.SET_SELECTED_EMPLOYEE_ID_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.SET_SELECTED_EMPLOYEE_ID_SUCCESS: {
      return {
        ...state,
        selectedEmployeeForId: action.employeeId ? action.employeeId : null,
        isLoading: false,
        error: null,
      };
    }

    case ActionTypes.CLEAR_SELECTED_REQUEST: {
      return {
        ...state,
        isLoading: false,
        selected: null,
        error: null,
        statuses: null,
        acts: null,
      };
    }
    case ActionTypes.CREATE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.CREATE_SUCCESS: {
      return orderAdapter.upsertOne(action.order, {
        ...state,
        selected: { ...action.order },
        isLoading: false,
        error: null,
      });
    }
    case ActionTypes.SAVE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.SAVE_SUCCESS: {
      return orderAdapter.upsertOne(action.order, {
        ...state,
        selected: { ...action.order },
        isLoading: false,
        error: null,
      });
    }
    case ActionTypes.LOAD_TEMPLATE_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
        template: null,
      };
    }
    case ActionTypes.LOAD_TEMPLATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        template: { ...action.template },
      };
    }
    case ActionTypes.SAVE_STATUS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.SAVE_STATUS_SUCCESS: {
      return orderAdapter.upsertOne(action.order, {
        ...state,
        selected: action.setSelected ? action.order : null,
        isLoading: false,
        error: null,
      });
    }
    case ActionTypes.LOAD_ACTS_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_ACTS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        acts: [...action.acts],
      };
    }
    case ActionTypes.LOAD_ALLOWED_STATUSES_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_ALLOWED_STATUSES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        error: null,
        statuses: [...action.statuses],
      };
    }
    case ActionTypes.CREATE_ACT_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_FOR_NOTIFICATION_REQUEST: {
      return {
        ...state,
        isLoadingForNotification: true,
        error: null,
      };
    }
    case ActionTypes.LOAD_FOR_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        isLoadingForNotification: false,
        error: null,
        forNotification: [...action.ordersForNotification],
      };
    }
    default: {
      return state;
    }
  }
}
